import {
  type AuthCheck2FAResponse,
  type AuthResponse,
  type RefreshTokenResponse,
  isAuthLoginResponse,
} from "@/features/auth/types/auth.type";
import type { User, UserResponse } from "@/shared/types/";

export const extractAccessToken = (data: AuthResponse | RefreshTokenResponse | AuthCheck2FAResponse | undefined): string | null => {
  return isAuthLoginResponse(data) ? data.access_token : null;
};

// `employeeUpdates` carries the fields saved during the onboarding (optional
// preferences), so the session profile matches the server without a refetch.
export const markLegalComplianceAccepted = (user: UserResponse, employeeUpdates: Partial<User> = {}): UserResponse => ({
  ...user,
  employee: { ...user.employee, ...employeeUpdates, legal_compliance_acceptance_required: false },
});

export const markLegalComplianceAcceptedOrNull = (
  user: UserResponse | undefined,
  employeeUpdates: Partial<User> = {},
): UserResponse | undefined => user && markLegalComplianceAccepted(user, employeeUpdates);
